/* ZETAW - Warp drop feed.
   Center piece sharp. Side pieces pour their outer edge toward the screen edge
   (stretched, blurred, funnel shaped) with a holo rim. WebGL, no library.
   Drag, trackpad swipe, arrows, keyboard. Falls back to a plain scroll row without WebGL. */
(function(){
  'use strict';

  var VS = [
    'attribute vec2 aPos;',
    'uniform vec4 uRect;',          /* x0,y0,x1,y1 in css px, origin screen center, y up */
    'uniform vec2 uResV;',
    'void main(){',
    '  vec2 p = mix(uRect.xy, uRect.zw, aPos);',
    '  gl_Position = vec4(p / (uResV * .5), 0., 1.);',
    '}'
  ].join('\n');

  var FS = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
    'precision highp float;',
    '#else',
    'precision mediump float;',
    '#endif',
    'uniform sampler2D uTex;',
    'uniform vec2 uRes;',
    'uniform float uDpr;',
    'uniform vec4 uCard;',          /* cx, cy, hw, hh */
    'uniform float uSide;',         /* -1 left, 0 center, 1 right */
    'uniform float uS;',            /* smear strength 0..1 */
    'uniform float uColor;',        /* 0 grey .. 1 colour */
    'uniform float uGrow;',         /* funnel growth at the screen edge */
    'uniform float uTime;',
    'uniform float uRad;',
    'uniform float uVel;',
    'float lum(vec3 c){ return dot(c, vec3(.299,.587,.114)); }',
    'vec3 holo(float t){ return .56 + .44 * cos(6.2831 * (t + vec3(0., .33, .67))); }',
    'void main(){',
    '  vec2 p = gl_FragCoord.xy / uDpr - uRes * .5;',
    '  vec2 q = p - uCard.xy;',
    '  float hw = uCard.z, hh = uCard.w;',
    '  float sd = uSide == 0. ? 1. : uSide;',
    '  float ax = q.x * sd;',
    '  vec3 col; float a;',
    '  if (uSide == 0. || ax <= hw){',
    '    if (abs(q.x) > hw || abs(q.y) > hh) discard;',
    '    vec2 d = abs(q) - vec2(hw, hh) + uRad;',
    '    float r = length(max(d, 0.)) - uRad;',
    '    if (r > .5) discard;',
    '    vec2 uv = vec2(q.x / (2. * hw) + .5, .5 - q.y / (2. * hh));',
    '    float ca = (uS * .014 + abs(uVel) * .01) * smoothstep(-hw, hw, ax);',
    '    vec3 c = vec3(texture2D(uTex, uv + vec2(ca * sd, 0.)).r, texture2D(uTex, uv).g, texture2D(uTex, uv - vec2(ca * sd, 0.)).b);',
    '    col = mix(vec3(lum(c)), c, uColor) * (1. - uS * .28);',
    '    float rim = 1. - smoothstep(0., 1.4, -r);',
    '    col = mix(col, vec3(.94, .925, .89), rim * .35);',
    '    a = 1. - smoothstep(-.5, .5, r);',
    '  } else {',
    '    float span = max(uRes.x * .5 - (uCard.x * sd) - hw, 1.);',
    '    float t = clamp((ax - hw) / span, 0., 1.);',
    '    float H = hh * (1. + uGrow * t * t + .15 * t);',
    '    float ay = abs(q.y);',
    '    if (ay > H) discard;',
    '    float v = .5 - q.y / (2. * H);',
    '    float u0 = uSide > 0. ? .995 : .005;',
    '    float back = .02 + .5 * t;',
    '    vec3 acc = vec3(0.);',
    '    for (int k = 0; k < 7; k++){',
    '      float f = float(k) / 6.;',
    '      acc += texture2D(uTex, vec2(u0 - sd * back * f, v + (f - .5) * .03 * t)).rgb;',
    '    }',
    '    acc /= 7.;',
    '    float L = lum(acc);',
    '    L = pow(L, 1. + t * .6);',
    '    col = vec3(L) * (1. - .45 * t);',
    '    float edge = H - ay;',
    '    float rim = 1. - smoothstep(0., 2. + 18. * t, edge);',
    '    vec3 h = holo(v * .9 + t * .7 + uTime * .06);',
    '    col = mix(col, h * (.7 + .3 * L), rim * .8);',
    '    col += (h - .5) * .22 * t;',
    '    a = uS * (1. - .15 * t);',
    '  }',
    '  gl_FragColor = vec4(col * a, a);',
    '}'
  ].join('\n');

  function compile(gl, type, src){
    var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s));
    return s;
  }

  function init(root, force){
    if (!root || root._zw) return;
    if (root.hasAttribute('data-zw-lazy') && !force) return;
    root._zw = true;
    var dataEl = root.querySelector('[data-zw-items]');
    var items = [];
    try { items = JSON.parse(dataEl.textContent || '[]').filter(function(x){ return x && (x.i || x.t); }); } catch (e) {}
    var fit = root.getAttribute('data-zw-fit') || 'cover';
    var stage = root.querySelector('[data-zw-stage]');
    var canvas = root.querySelector('[data-zw-canvas]');
    var info = root.querySelector('[data-zw-info]');
    var counter = root.querySelector('[data-zw-count]');
    var fallback = root.querySelector('[data-zw-fallback]');
    if (!items.length || !stage || !canvas) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var gl = null;
    try { gl = canvas.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: true }) || canvas.getContext('experimental-webgl'); } catch (e) {}
    if (!gl){ root.classList.add('is-fallback'); return; }

    var prog;
    try {
      prog = gl.createProgram();
      gl.attachShader(prog, compile(gl, gl.VERTEX_SHADER, VS));
      gl.attachShader(prog, compile(gl, gl.FRAGMENT_SHADER, FS));
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error('link');
    } catch (e){ root.classList.add('is-fallback'); return; }
    gl.useProgram(prog);
    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0,0, 1,0, 0,1, 1,1]), gl.STATIC_DRAW);
    var aPos = gl.getAttribLocation(prog, 'aPos');
    gl.enableVertexAttribArray(aPos);
    gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);
    var U = {};
    ['uRect','uRes','uResV','uDpr','uCard','uSide','uS','uColor','uGrow','uTime','uRad','uVel','uTex'].forEach(function(n){ U[n] = gl.getUniformLocation(prog, n); });
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    gl.uniform1i(U.uTex, 0);

    /* textures: square, cover-cropped through a 2D canvas */
    var TEX = 768;
    function blankTex(){
      var t = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, t);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([22, 22, 21, 255]));
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      return t;
    }
    var cards = items.map(function(it){ return { it: it, tex: blankTex(), ready: false }; });
    function placeholder(c){
      try {
        var cv = document.createElement('canvas'); cv.width = cv.height = TEX;
        var x = cv.getContext('2d');
        x.fillStyle = '#111110'; x.fillRect(0, 0, TEX, TEX);
        x.strokeStyle = 'rgba(240,236,227,.18)'; x.lineWidth = 2;
        for (var k = -TEX; k < TEX; k += 28){ x.beginPath(); x.moveTo(k, TEX); x.lineTo(k + TEX, 0); x.stroke(); }
        x.fillStyle = '#0a0a0a'; x.fillRect(TEX * .12, TEX * .38, TEX * .76, TEX * .24);
        x.strokeStyle = 'rgba(240,236,227,.5)'; x.strokeRect(TEX * .12, TEX * .38, TEX * .76, TEX * .24);
        x.fillStyle = '#f0ece3'; x.textAlign = 'center';
        x.font = '64px "Bebas Neue", Impact, "Arial Narrow", sans-serif';
        x.fillText(String(c.it.t || '').toUpperCase().slice(0, 22), TEX / 2, TEX * .5);
        x.fillStyle = '#8a867d'; x.font = '34px "Bebas Neue", Impact, "Arial Narrow", sans-serif';
        x.fillText('CLASSIFIED // COMING SOON', TEX / 2, TEX * .57);
        gl.bindTexture(gl.TEXTURE_2D, c.tex);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, cv);
      } catch (e) {}
    }
    function loadTex(c){
      if (!c.it.i){ placeholder(c); if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ placeholder(c); }); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function(){
        if (c.dead) return;
        try {
          var cv = document.createElement('canvas'); cv.width = cv.height = TEX;
          var cx = cv.getContext('2d');
          cx.fillStyle = '#0b0b0b'; cx.fillRect(0, 0, TEX, TEX);
          if (fit === 'contain'){
            /* the whole picture, over a dark blurred copy of itself */
            var sb = Math.max(TEX / img.naturalWidth, TEX / img.naturalHeight);
            cx.save(); cx.filter = 'blur(28px) brightness(.35)';
            cx.drawImage(img, (TEX - img.naturalWidth * sb) / 2, (TEX - img.naturalHeight * sb) / 2, img.naturalWidth * sb, img.naturalHeight * sb);
            cx.restore();
            var sc = Math.min(TEX / img.naturalWidth, TEX / img.naturalHeight) * .92;
            var w2 = img.naturalWidth * sc, h2 = img.naturalHeight * sc;
            cx.drawImage(img, (TEX - w2) / 2, (TEX - h2) / 2, w2, h2);
          } else {
            var s = Math.max(TEX / img.naturalWidth, TEX / img.naturalHeight);
            var w = img.naturalWidth * s, h = img.naturalHeight * s;
            cx.drawImage(img, (TEX - w) / 2, (TEX - h) / 2, w, h);
          }
          gl.bindTexture(gl.TEXTURE_2D, c.tex);
          gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, cv);
          c.ready = true; dirty = true;
        } catch (e) {}
      };
      img.src = c.it.i;
    }
    cards.forEach(loadTex);

    /* layout */
    var W = 0, H = 0, dpr = 1, cardW = 300, sideScale = .72, spacing = 360, mobile = false;
    function layout(){
      var r = stage.getBoundingClientRect();
      W = Math.max(1, r.width); H = Math.max(1, r.height);
      dpr = Math.min(window.devicePixelRatio || 1, 1.75);
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      mobile = W < 700;
      if (mobile){
        cardW = Math.min(W * .6, H * .7);
        sideScale = .42;
        spacing = W * .5 - cardW * sideScale * .5 - W * .08;   /* side pieces tucked behind, smear to the edge */
      } else {
        cardW = Math.min(W * .27, H * .72, 480);
        sideScale = .72;
        spacing = cardW * .5 + cardW * sideScale * .5 + Math.max(W * .05, 40);
      }
      gl.viewport(0, 0, canvas.width, canvas.height);
      dirty = true; placeInfo();
    }

    /* motion */
    var n = cards.length, pos = 0, target = 0, vel = 0, dragging = false, dragX = 0, dragPos = 0, lastX = 0, lastT = 0, moved = 0;
    var dirty = true, visible = true, raf = 0, t0 = performance.now(), current = -1;
    function clampT(v){ return Math.max(0, Math.min(n - 1, v)); }
    function go(i){ target = clampT(Math.round(i)); dirty = true; kick(); }

    function geom(i){
      var off = i - pos, a = Math.abs(off);
      var s = Math.min(1, a);
      var scale = 1 - (1 - sideScale) * s;
      var x = Math.sign(off) * (a <= 1 ? a * spacing : spacing + (a - 1) * spacing * 1.15);
      var hw = cardW * scale * .5;
      return { off: off, s: s, x: x, hw: hw, hh: hw, side: a < .02 ? 0 : Math.sign(off) };
    }

    function draw(now){
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
      gl.uniform2f(U.uRes, W, H);
      gl.uniform2f(U.uResV, W, H);
      gl.uniform1f(U.uDpr, dpr);
      gl.uniform1f(U.uTime, (now - t0) / 1000);
      gl.uniform1f(U.uRad, Math.max(6, cardW * .03));
      gl.uniform1f(U.uVel, Math.max(-1, Math.min(1, vel * 3)));
      var order = cards.map(function(c, i){ return i; }).sort(function(a, b){ return Math.abs(b - pos) - Math.abs(a - pos); });
      order.forEach(function(i){
        var g = geom(i), c = cards[i];
        if (Math.abs(g.x) - g.hw > W * .5 + 2) return;
        var x0, x1;
        if (g.side > 0){ x0 = g.x - g.hw; x1 = Math.max(g.x + g.hw, W * .5); }
        else if (g.side < 0){ x0 = Math.min(g.x - g.hw, -W * .5); x1 = g.x + g.hw; }
        else { x0 = g.x - g.hw; x1 = g.x + g.hw; }
        var grow = Math.max(0, (H * .5 + 4) / g.hh - 1);
        gl.uniform4f(U.uRect, x0, -H * .5, x1, H * .5);
        gl.uniform4f(U.uCard, g.x, 0, g.hw, g.hh);
        gl.uniform1f(U.uSide, g.side);
        gl.uniform1f(U.uS, mobile ? g.s * .9 : g.s);
        gl.uniform1f(U.uGrow, grow);
        var col = c.it.a === false ? 0 : Math.max(0, 1 - g.s * 1.4);
        gl.uniform1f(U.uColor, col);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, c.tex);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      });
    }

    function tick(now){
      raf = 0;
      if (!visible) return;
      if (!dragging){
        var k = reduce ? 1 : .14;
        var d = target - pos;
        vel = d * k;
        pos += vel;
        if (Math.abs(d) < .0008){ pos = target; vel = 0; }
      }
      draw(now);
      var ci = Math.round(pos);
      if (ci !== current){ current = ci; updateInfo(); }
      root.classList.toggle('is-moving', Math.abs(target - pos) > .02 || dragging);
      placeInfo();
      raf = requestAnimationFrame(tick);   /* keeps the holo rim shimmering while visible */
    }
    function kick(){ if (!raf && visible) raf = requestAnimationFrame(tick); }

    /* info on the center card */
    function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(ch){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
    function updateInfo(){
      var it = items[clampT(current)];
      if (counter) counter.textContent = String(clampT(current) + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
      if (!info || !it) return;
      if (it.u){ info.href = it.u; info.removeAttribute('tabindex'); } else { info.removeAttribute('href'); info.setAttribute('tabindex', '-1'); }
      var pill = it.k != null ? (it.k ? '<span class="zw-pill"><i></i>' + esc(it.k) + '</span>' : '') :
        '<span class="zw-pill' + (it.a ? ' is-live' : '') + '"><i></i>' + (it.a ? 'Available' : 'Sold') + '</span>';
      var line = it.d != null ? esc(it.d) : esc(it.p || '') + (it.u ? ' <em>Open the file →</em>' : '');
      info.innerHTML =
        '<span class="zw-info__top"><span>' + esc(it.s || '') + '</span>' + pill + '</span>' +
        '<span class="zw-info__bottom"><b>' + esc(it.t) + '</b>' + (line ? '<span>' + line + '</span>' : '') + '</span>';
      info.setAttribute('aria-label', it.t + (it.u ? ', open the file' : ''));
      try { root.dispatchEvent(new CustomEvent('zw:change', { detail: { index: clampT(current) } })); } catch (e) {}
    }
    function placeInfo(){
      if (!info) return;
      var hw = cardW * .5;
      info.style.width = (hw * 2) + 'px';
      info.style.height = (hw * 2) + 'px';
      info.style.transform = 'translate(-50%,-50%) translateX(' + ((Math.round(pos) - pos) * spacing).toFixed(1) + 'px)';
    }

    /* input */
    function hitIndex(clientX){
      var r = stage.getBoundingClientRect(), x = clientX - r.left - W / 2;
      var best = -1, bd = 1e9;
      for (var i = 0; i < n; i++){ var g = geom(i); if (Math.abs(x - g.x) < g.hw && Math.abs(x - g.x) < bd){ bd = Math.abs(x - g.x); best = i; } }
      return best;
    }
    stage.addEventListener('pointerdown', function(e){
      if (e.button !== 0) return;
      dragging = true; moved = 0; dragX = lastX = e.clientX; dragPos = pos; lastT = performance.now(); vel = 0;
      stage.setPointerCapture(e.pointerId); root.classList.add('is-dragging'); kick();
    });
    stage.addEventListener('pointermove', function(e){
      if (!dragging) return;
      var dx = e.clientX - dragX; moved = Math.max(moved, Math.abs(dx));
      var np = dragPos - dx / spacing;
      if (np < 0) np = np * .35; if (np > n - 1) np = n - 1 + (np - (n - 1)) * .35;
      var now = performance.now(), dt = Math.max(1, now - lastT);
      vel = (-(e.clientX - lastX) / spacing) * (16 / dt);
      lastX = e.clientX; lastT = now;
      pos = np; target = clampT(Math.round(pos)); dirty = true;
    });
    function up(e){
      if (!dragging) return;
      dragging = false; root.classList.remove('is-dragging');
      if (moved < 6){
        var hit = hitIndex(e.clientX);
        if (hit === Math.round(pos) && items[hit] && items[hit].u){ window.location.href = items[hit].u; return; }
        if (hit > -1) go(hit);
        else go(pos);
      } else go(pos + vel * 6);
    }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', function(){ dragging = false; root.classList.remove('is-dragging'); go(pos); });
    var wheelAcc = 0, wheelT = 0;
    stage.addEventListener('wheel', function(e){
      var dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
      if (!dx) return;
      e.preventDefault();
      wheelAcc += dx;
      var now = performance.now();
      if (Math.abs(wheelAcc) > 60 && now - wheelT > 260){ go(target + (wheelAcc > 0 ? 1 : -1)); wheelAcc = 0; wheelT = now; }
    }, { passive: false });
    root.addEventListener('keydown', function(e){
      if (e.key === 'ArrowRight'){ e.preventDefault(); go(target + 1); }
      else if (e.key === 'ArrowLeft'){ e.preventDefault(); go(target - 1); }
    });
    root.querySelectorAll('[data-zw-prev]').forEach(function(b){ b.addEventListener('click', function(){ go(target - 1); }); });
    root.querySelectorAll('[data-zw-next]').forEach(function(b){ b.addEventListener('click', function(){ go(target + 1); }); });
    if (info) info.addEventListener('click', function(e){ if (moved >= 6) e.preventDefault(); });

    /* size + visibility */
    if ('ResizeObserver' in window) new ResizeObserver(layout).observe(stage); else window.addEventListener('resize', layout);
    if ('IntersectionObserver' in window) new IntersectionObserver(function(en){ visible = en[0].isIntersecting; if (visible) kick(); }).observe(stage);
    canvas.addEventListener('webglcontextlost', function(e){ e.preventDefault(); root.classList.add('is-fallback'); });

    var start = root.dataset.start != null ? (parseInt(root.dataset.start, 10) || 0) : Math.floor((n - 1) / 2);
    pos = target = clampT(start);
    root._zwGo = go;
    /* swap the whole feed for new pieces (used by the collection feed "reload") */
    root._zwSet = function(list, startAt){
      var next = (list || []).filter(function(x){ return x && (x.i || x.t); });
      if (!next.length) return;
      cards.forEach(function(c){ c.dead = true; try { gl.deleteTexture(c.tex); } catch (e) {} });
      items = next;
      cards = items.map(function(it){ return { it: it, tex: blankTex(), ready: false }; });
      cards.forEach(loadTex);
      n = cards.length;
      var st = clampT(startAt != null ? startAt : Math.floor((n - 1) / 2));
      target = st; pos = reduce ? st : st - 2.6; vel = 0; current = -1;
      dirty = true; kick();
    };
    layout(); updateInfo(); kick();
    root.classList.add('is-ready');
  }

  window.ZetawWarp = { init: function(el){ init(el, true); } };
  function boot(scope){ Array.prototype.forEach.call((scope || document).querySelectorAll('[data-zetaw-warp]'), function(el){ init(el, false); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); }); else boot();
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
